import "./Footer.css";
import {
  FaLinkedinIn,
  FaYoutube,
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaEnvelope,
} from "react-icons/fa";
import logo2 from "../assets/logo2.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        
        <div className="footer-left">
          <img
            src={logo2}
            alt="XRAPY logo featuring a modern design, representing a technology company based in Beirut, Lebanon"
            className="footer-logo"
          />
          <p>Beirut, Lebanon</p>

          <a href="mailto:info@xrapy.com" className="footer-email">
            <FaEnvelope /> info@xrapy.com
          </a>
        </div>

        
        <div></div>

       
        <div className="footer-socials">
          <a
            href="https://www.linkedin.com/company/xrapy/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>

          <a
            href="https://www.youtube.com/@xrapy-ai"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <FaYoutube />
          </a>

          <a
            href="https://wa.me/9613820015"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>

          <a
            href="https://www.facebook.com/people/XRapy/61553085055231/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FaFacebookF />
          </a>

          <a
            href="https://www.instagram.com/xrapy_sarl/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
        </div>

        
        <div className="footer-right">
          © 2026 XRAPY — Powered by XRAPY
        </div>

      </div>
    </footer>
  );
};

export default Footer;
